import React from "react";
import { checkIfQuestionsHasBeenModified } from "../../helpers/questions/functions";
import { filterActiveOptions } from "../../helpers/functions";
import { Link, HorizontalRule, FormGroup } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS, INPUT_TYPE } from '../../helpers/formGroupVariants';
import CONTENT_STRINGS from "../../helpers/contentStrings";
import {
    OPPONENT_NAME_MN,
    TERTIARY,
    LEFT,
    PALE,
    APPLICATION_OPPONENT,
    INITIAL_OPTIONS,
    OPPONENT_QUESTION_NAME_MAPPING,
} from "../../helpers/constants";
import QuestionEditActions from "./QuestionEditActions";
import OpponentChildQuestion from "./opponentChildQuestion";

const OpponentQuestion = (props) => {
    const {
        opponent,
        opponentQuestions,
        openHistoryModal,
        application,
        isPlain,
        question,
        checkIfPlainEditable,
        opponentHandler,
        opponentIndex,
        mapEditingQuestionOrFieldToEditingSetting,
        openEditQuestionAnswerModal,
        approvalOptions,
        displayRemoveButton,
        onClickActionLink,
        opponentHasPendingChanges,
        isApplicationTab,
    } = props;

    const onClickRemoveOpponent = () => {
        onClickActionLink(isPlain, opponentIndex, opponent, question);
    }

    const onClickEditAnswer = () => {
        openEditQuestionAnswerModal({
            questionAnswerForEdit: question,
            questionAnswer: opponent.name,
            questionAnswerOpponent: opponent
        });
    }

    const checkIsLabelClickable = (machineName) => {
        return checkIfQuestionsHasBeenModified(
            opponent.id,
            application,
            OPPONENT_NAME_MN,
            machineName
        ) && isApplicationTab;
    }

    const getInputName = (machineName) => {
        return OPPONENT_QUESTION_NAME_MAPPING[machineName];
    }
    const getOptions = (question, selectedOptionId = null) => {
        if (!question.hasOwnProperty('options')) {
            return [];
        }
        return [...INITIAL_OPTIONS, ...filterActiveOptions(question.options, selectedOptionId)
            .map(option => ({
                key: option.id,
                label: option.name
            }))];
    }

    return (
        <>
            {
                displayRemoveButton 
                ?
                    <>
                        <HorizontalRule variant={PALE} />
                        <Link
                            onClick={onClickRemoveOpponent}
                            label={CONTENT_STRINGS.REMOVE}
                            variant={TERTIARY}
                            arrowDirection={LEFT}
                            linkTestId={'policy-application-OpponentRemove'}
                        />
                    </>
                : 
                    null
            }
            {opponentQuestions.map((oppQuestion) => {
                const isLabelClickable = checkIsLabelClickable(oppQuestion.machineName);
                const hasInlineElements = checkIfPlainEditable(oppQuestion, APPLICATION_OPPONENT) || opponentHasPendingChanges;
                const label = isPlain ? opponent.name : "";
                const value = isPlain ? "" : opponent.name;
                const variant = isPlain ? FORM_GROUP_VARIANTS.PLAIN : FORM_GROUP_VARIANTS.TEXT;
                return (
                    <React.Fragment key={oppQuestion.id}>
                        {
                            oppQuestion.inputType === INPUT_TYPE.TEXT 
                            ?
                                <FormGroup
                                    labelSize={'col-sm-3'}
                                    inputSize={'col-sm-6'}
                                    label={oppQuestion.name}
                                    variant={variant}
                                    inputProps={{
                                        id: `question-id-${oppQuestion.id}`,
                                        name: 'name',
                                        label: label,
                                        value: value,
                                        required: oppQuestion.isRequired,
                                        onChange: (evt) => opponentHandler(evt.target.name, evt.target.value, opponentIndex),
                                    }}
                                    onLabelClick={ isLabelClickable ? () => openHistoryModal(oppQuestion, opponent.id) : undefined }
                                    hasInlineElements={hasInlineElements}
                                    inlineGroupElements={
                                        <div className={"col-sm-3"}>
                                            <QuestionEditActions
                                                checkIfPlainEditable={checkIfPlainEditable(oppQuestion, APPLICATION_OPPONENT)}
                                                question={oppQuestion}
                                                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                                                approvalOptions={approvalOptions}
                                                onClick={onClickEditAnswer}
                                                hasPendingChanges={opponentHasPendingChanges}
                                            />
                                        </div>
                                    }
                                    formGroupTestId={`policy-application-${question.machineName}`}
                                />
                            :
                                null
                        }
                        {
                            oppQuestion.inputType === INPUT_TYPE.DROP_DOWN 
                            ?
                                <OpponentChildQuestion
                                    oppQuestion={oppQuestion}
                                    opponent={opponent}
                                    opponentHandler={opponentHandler}
                                    opponentIndex={opponentIndex}
                                    isPlain={isPlain}
                                    isLabelClickable={isLabelClickable}
                                    openHistoryModal={openHistoryModal}
                                    application={application}
                                    getInputName={getInputName}
                                    getOptions={getOptions}
                                    isApplicationTab={isApplicationTab}
                                />
                            : 
                                null
                        }
                    </React.Fragment>
                )
            })}
        </>
    )
}

export default OpponentQuestion;